

























































































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import MagicValidator from "../../../magic/MagicValidator.vue";
import { dateFormat } from "@szgc/plt-core-v2";

@Component({
  name: "DateRangeWidget",
  components: { MagicValidator }
})
export default class DateRangeWidget extends WidgetBase implements App.PuttedWidgetComponent {
  setValue(value: string) {
    console.log(value);
  }

  get dateRangeTextStr() {
    if (this.value.length === 2) {
      const start = dateFormat(this.value[0], "YYYY年MM月DD日");
      const end = dateFormat(this.value[1], "YYYY年MM月DD日");
      return start + "至" + end;
    }
    return "";
  }

  get dateRangeText() {
    if (this.value.length === 2) {
      const start = dateFormat(this.value[0], this.widget.widgetFormat || "YYYY-MM-DD");
      const end = dateFormat(this.value[1], this.widget.widgetFormat || "YYYY-MM-DD");
      return start + this.widget.separator + end;
    }
    return "";
  }
}
